exports.list = {
    path: '/list_project',
    name: 'list_project_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/list_project/List.vue"),
}
exports.show = {
    path: '/list_project/show/:id',
    name: 'list_project_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/list_project/Show.vue"),
}